import { Box, IconButton } from "@mui/material";
// import { ReactComponent as FileDownload } from "@deere/ux.brand-foundations/icons/file_download.svg";
import { useAs2Client } from "../../as2-onboarding-component/hooks/useClient";
import { useOktaAuth } from "@okta/okta-react";

export default function RenderDownload(props) {
  const { oktaAuth } = useOktaAuth();
  const client = useAs2Client(oktaAuth.getAccessToken());

  const { value } = props;
  let icon;
  if (value) {
    icon = (
      <IconButton
        aria-label="Download file"
        onClick={() => downloadRawFile(props.id)}
      >
        {" "}
        <fuel-icon name={"download"} />
      </IconButton>
    );
  }

  const downloadRawFile = (id) => {
    const queryString = `/api/as2/communication-status/files/download?id=${id}`;
    client
      .get(queryString)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        const fileName =
          response.headers["content-disposition"].split("filename=")[1];
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => console.log(error, error?.response));
  };

  return (
    <Box alignItems={"center"} display={"flex"} flexDirection={"row"}>
      {icon}
    </Box>
  );
}
